import axios from 'axios';
import { Message, Notification } from 'zz-element-ui';
import { under2Camal, camel2Under } from '../utils/camal-case-covertor';
import { _local } from '@/utils/storage';
import { redictToLogin } from '@/utils';
import Cookies from 'js-cookie';
import router from '@/router';
import store from '@/store';

// Set baseURL when debugging production url in dev mode
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.withCredentials = true;
axios.interceptors.request.use(
  config => {
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// http response 响应拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 301:
          window.location.href = error.response.data.data.redirect;
          break;
        case 401:

          Cookies.set('systemId', '3', {
            domain: process.env.VUE_APP_DOMAIN,
            expires: 7,
          });
          Cookies.remove('domain', { domain: process.env.VUE_APP_DOMAIN, expires: 0 })
          redictToLogin()
          break;
        case 403:
          if (!store.state.user.authority) {
            router.replace('/authority')
          }
          store.commit('user.setAuthority', true)
          break;
        default:
          if (
            (error.response.data && error.response.data.msg) ||
            (error.response.data.error || error.response.data.message) ||
            (error.response.status === 500 && error.response.data.message)
          ) {
            if (!error.response.data.notMsg) {
              window.eventBus.$message && window.eventBus.$message.error(
                error.response.data.msg ||
                error.response.data.message ||
                error.response.data.error ||
                window.eventBus.$t('system::error::serve')
              );
            }
          }
      }
      // if ((error.response.data && error.response.data.msg) || (error.response.data.error || error.response.data.message) || (error.response.status === 500 && error.response.data.message)) {
      //   if (!error.response.data.notMsg) {
      //     window.eventBus.$message.error(error.response.data.msg || error.response.data.message || error.response.data.error || '服务错误，请稍后重试')
      //   }
      // }

      // 返回接口返回的错误信息
      return Promise.reject(error.response.data);
    }
  }
);

/**
 * Method to make ajax request
 *
 * @param {object} options - axios config (https://github.com/axios/axios#request-config)
 */
export async function request(options, isFetch) {
  try {
    const token = _local.get('saasToken') || Cookies.get('saasToken');
    options.headers = options.headers || {};
    // 登陆接口跳过鉴权
    if (!options.fileJSON && !options.url.includes('login-auth')) {
      options.headers['user-id'] = _local.get('userId') || null;
      options.headers['user-name'] =
        encodeURIComponent(_local.get('userName')) || null;
      options.headers['x-language'] = Cookies.get('language') || null;
      options.headers['system-id'] = options.headers.systemId || 3;
      const curTab = store.state.menu.curTab
      options.headers['folder-name'] = curTab ? encodeURIComponent(curTab.uniName || curTab.meta.name || curTab.name) : null ;
     
      // 获取商家列表不需要merchantID
      if (store.state.user.merchantId && !options.url.includes('/permission/authorized/merchant/list')) {
        if (!options.headers.systemId) {
          options.headers['merchant-id'] = store.state.user.merchantId || '';
        }
      }
     
      delete options.headers.systemId
      //  TODO: BI
      if (options.headers && options.headers.token) {
        options.headers.Authorization = _local.get('saasToken') || Cookies.get('saasToken');
        if (options.params) {
          options.params = under2Camal(options.params);
        }
      } else if (token) {
        options.headers.Authorization = token;
        if (options.coverData !== false) {
          if (options.params) {
            options.params = camel2Under(options.params);
          }
          if (
            options.data &&
            options.headers['Content-Type'] !==
            'application/x-www-form-urlencoded'
          ) {
            options.data = camel2Under(options.data);
          }
        }
      } else if (options.islogin) { } else {
        // 无token情况直接跳转不再做提示
        Cookies.remove('domain', { domain: process.env.VUE_APP_DOMAIN, expires: 0 })
        redictToLogin()
        return;
      }
    }

    /**
     * 返回远程请求数据
     */
    const response = await axios(options);
    if (options.fileJSON) {
      return { response, code: 0 };
    }
    if (options.csv) {
      return { code: 0, response };
    }

    if (response.data instanceof Blob) {
      if (response.config.headers && response.config.headers.token) {
        return { status: 200, response };
      }

      return { code: 0, response };
    }
    let { data } = handleResponse(response, options);
    // if (options.coverData !== false) {
    //   data = under2Camal(data)
    // }
    //  TODO: BI
    if (options.headers && options.headers.token) {
      return {
        ...data,
      };
    } else {
      if (options.coverData !== false) {
        data = under2Camal(data);
      }
      return { response, data };
    }
    // return { response, data }
  } catch (error) {
    const response = {
      data: error,
    };
    if (options.notMsg) {
      response.data.notMsg = options.notMsg;
    }
    return { response, data: response.data };
  }
}

/**
 * Custom response data handler logic
 *
 * @param {object} response - response data returned by request
 * @return {object} data or error according to status code
 */
function handleResponse(response, options) {
  const { data, status } = response;
  if (response.config.headers.buried) {
    return {};
  }

  // 仅自定义报表携带
  if (status === 200 && response.config.headers.token) {
    if (data.code !== 0) {
      // console.log(data, 123123);
      data.msg && window.eventBus.$message.error(data.msg);
    }
    if (data.code === 60036) {
      if (!store.state.user.isExpired) {
        router.replace('/expired')
      }
      store.commit('user.setIsExpired', true)
    }
    return response.headers && response.headers.responseType
      ? { data }
      : { data: { status: 200, result: data } };
  }
  if (data.code === 0) {
    return { data };
  } else if (
    data.code === 60005 ||
    data.code === 60006 ||
    data.code === 60030 ||
    data.code === 10001
  ) {
    Cookies.remove('domain', { domain: process.env.VUE_APP_DOMAIN, expires: 0 })
    redictToLogin()
  } else if (data.code === 60036) {
    if (!store.state.user.isExpired) {
      router.replace('/expired')
    }
    store.commit('user.setIsExpired', true)
  } else if (data.code === 40002 || data.code == 10002 && ['GET_MERCHANT_TYPE_ERROR', 'AUTHORIZE_ERROR'].includes(data.errorCode)) {
    window.eventBus.$message && window.eventBus.$message.error(window.$t('system::error::authrized'));
  } else {
    // 不存在$notMsg时页面报错
    if (!options.notMsg) {
      if (options.errorType === 'notice') {
        Notification.error({
          title: data.msg,
          desc: data.msg_detail,
        });
      } else {
        window.eventBus.$message && window.eventBus.$message.error(data.msg);
      }
    }
    return { data };
  }
}
